import React,{ useEffect, useState, } from 'react';
import { useSelector,useDispatch } from 'react-redux';
import { formatNumber, CTicksToDateStringRemainTime, formatTotalTime } from '../Utility.js';
import { useNavigate } from 'react-router-dom';

function Private()
{

    return (        
        <div style={{ maxWidth:'100%', maxHeight:'100%', whiteSpace: "pre-wrap", padding: "20px", fontFamily: "Arial, sans-serif", backgroundColor:'white', color:'black', overflowY:'scroll'}}>
        {`
개인정보처리방침
시행일자 : 2025.02.14
총칙
㈜스포토(이하 '회사'라 함) 회원의 개인정보를 적극적으로 보호하며, 『정보통신망이용촉진 및 정보보호 등에 관한 법률(이하 “정보통신망법”』), 『개인정보보호법』 등
정보통신서비스 제공자가 준수하여야 하는 관련 법령을 준수함으로써 회원 권익 보호에 최선을 다하고 있습니다.
회사는 본 개인정보처리방침을 통해 회원이 제공하는 개인정보를 어떠한 목적과 방식으로 이용하고 있는지, 회원의 개인정보를 보호하기 위해 회사가 어떠한 노력을 기울이고 있는지 알려드립니다.
<제 1조> 개인정보의 수집 항목과 이용목적 및 방법
회사는 서비스 제공을 위하여 필요한 정보를 아래와 같은 목적으로 필수/선택 정보로 구분하여, 회원의 동의 하에 수집하고 있습니다.
아래의 목적으로 수집되는 정보들은 필수 수집 안내 및 선택 동의하거나, 서비스 이용 과정에서 회원이 직접 입력, 개별 동의함으로써 수집됩니다.
구분	수집 및 이용목적	필수/선택	수집항목
회원 가입	회원 가입	필수	[멤버십] 아이디, 비밀번호, 휴대폰번호, 이메일 주소
맞춤형 광고	선택	광고식별자, 서비스 이용기록, 쿠키(Cookie)
고객 상담	이용자 식별 및 연락	필수	이메일 주소, 연락처(휴대폰 번호, 일반전화번호)
상담내용 확인	필수	ID, 이름, 닉네임, 기타 상담에 필요한 정보
결제/환불	결제	필수	신용카드 : 신용카드: 카드사명, 카드번호, 유효기간, cvc
(결제 방식에 따라 수집 정보가 상이할 수 있습니다)
휴대전화 : 휴대폰번호, 통신사명
계좌이체 : 은행명, 계좌번호, 현금영수증정보
가상계좌 : 은행명, 입금자명, 현금영수증정보

*실제 유료 결제에 필요한 정보는 google사에서 수집하고 있습니다.
취소 또는 환불	필수	은행명, 계좌번호, 예금주
*본인 여부 확인을 위해 신분증, 가족관계증명서,
휴대폰가입증명서, 등/초본, 통장사본, 충전 방식 별 완납 영수증 및 완납 서류가 수집될 수 있습니다.
(충전방식에 따라 취소에 필요한 수집내용이 달라질 수 있습니다)
서비스 이용	부정행위 탐지를 위한 기타정보 자동수집	필수	
기기정보, 이동통신사정보, IP, 접속기록, 서비스 이용기록, 불량이용기록, 다운로드 기록, 대금결제 기록, 쿠키(Cookie)

서비스 이용과정에서 정보를 자동화된 방법으로 생성하여 저장하거나, 고유한 정보를 원래의 값을 확인하지 못하도록 안전하게 변환하여 수집합니다. 연계 여부에 따라 개인 정보에 해당할 수도, 해당하지 않을 수도 있습니다.

<제 2조> 개인정보의 보유 및 이용기간
㈜스포토는 (이하 ‘회사’) “정보통신망 이용촉진 및 정보보호 등에 관한 법률” 및 “개인정보보호법”에 따라 이용자의 개인정보를 제3자에게 제공해야 하는 경우 동의를 받고 있으며, 동의한 경우 이외에는 개인정보를 제3자에게 제공하지 않습니다.
회사는 회원의 개인정보를 고지 및 동의 받은 기간 동안 보유하고 이용하며, 개인정보의 수집 및 이용목적이 달성되거나 보유기간 만료, 이용자의 수집 및 이용 동의 철회 시 지체없이 파기하는 것을 원칙으로 합니다.
최종 로그인 후 계속해서 365일 동안 이용 기록이 없는 장기 미 접속자에 대해서는 관계 법령에 따라 개인정보 보호를 위해 계약을 해지하고 개인정보 파기 등 필요한 조치를 취할 수 있습니다.
이 경우, 조치일 30일 전까지 필요한 조치가 취해진다는 사실과 개인정보 보유기간 만료일 및 개인정보의 항목을 “회원”에게 사전에 등록한 전자메일을 통해 고지합니다.
게임 서비스를 지속적으로 이용하고자 하는 경우, 최종 로그인 일시로부터 365일이 경과하기 전까지 로그인 하시기 바랍니다.
회사는 개인정보 도용 등으로 인한 피해 발생시 복구와 피해자 보호 등을 위해 회원의 성명, 연락처 등 회원가입 시 수집한 개인정보를 해지한 날로부터 최대 14일 동안 임시 보관할 수 있으며,
ID는 타 서비스와의 연계로 인해 30일간 보유하고 이후에는 재생할 수 없는 방법으로 완전히 삭제 됩니다.
다음의 정보에 대해서는 “보존 근거” 및 법령에서 명시한 기간 동안 보존합니다.
① 이벤트 및 서비스 마케팅을 위해 수집한 정보
- 수집 목적 달성 후 3개월 보관 (이벤트 마다 보관 일수가 다를 수 있으며, 개별 이벤트에 적용된 기간을 우선 적용)
② 관련 법령에 따라 일정기간 보존해야 하는 경우
관련 법령	수집 정보	보유 기간
정보통신망 이용촉진 및 정보보호 등에 관한 법률	로그인 정보	1년
통신비밀보호법	서비스 이용 관련 정보	3개월
전자상거래 등에서의 소비자 보호에 관한 법률	소비자의 불만 또는 분쟁처리에 관한 기록	3년
표시/광고에 관한 기록	6개월
계약 또는 청약철회 등에 관한 기록	5년
대금결제 및 재화 등의 공급에 관한 기록	5년
국세기본법	세법이 규정하는 모든 거래에 관한 장부 및 증빙서류	5년
<제 3조> 개인정보의 파기절차 및 방법
이용자의 개인정보는 수집 및 이용목적이 달성되면 지체 없이 파기되며, 파기 절차 및 방법은 다음과 같습니다.
파기절차	이용자가 회원가입 등을 위해 입력한 정보는 목적이 달성된 후 내부 방침 및 기타 관련 법령에 의한 보관 기간 동안 보관된 후 파기
파기방법	출력물 형태 : 분쇄기로 분쇄하거나 소각을 통하여 파기
전자적 파일 형태 : 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제
<제 4조> 고유식별정보의 처리
고유식별정보란 『개인정보보호법』 및 동 시행령에서 “대통령령으로 정하는 정보”로 주민등록번호, 여권번호, 운전면허번호, 외국인등록번호를 말합니다.
회사는 아래와 같은 목적으로 고유식별정보를 수집하여 처리하고 있습니다.
- 현물 경품 당첨자의 제세공과금 처리
<제 5조> 개인정보의 제공 및 공유
회사는 새로운 기술 개발과 보다 나은 서비스 제공을 위하여 회원의 개인정보를 공유할 수 있습니다.
이 경우에도 정보 수집 또는 정보 제공 이전에 회원에게 개인정보를 공유할 기관이나 단체, 비즈니스 파트너가 누구인지, 어떤 정보가 왜 필요한지,
그리고 언제까지 어떻게 보호되고 관리되는지 알려드리고 동의를 구하는 절차를 거치게 됩니다.
회원의 동의가 없는 경우에는 추가적인 정보를 임의로 수집하거나 공유하지 않습니다.
성별, 연령별 기타 특정 조건의 집단에 대한 광고 게재 및 발송 시에도 회원의 개인정보는 광고를 의뢰한 개인이나 기업 등에 제공되지 않으며,
기타 통계처리나 학술연구, 시장조사 등 공공의 목적달성을 위하여 제공이 필요한 경우에도 특정한 개인을 식별할 수 없는 형태로만 제공됩니다.
회사는 원칙적으로 이용자의 개인정보를 외부에 제공하지 않습니다. 다만, 아래의 경우 예외로 합니다.
① 이용자가 사전에 공개 또는 제공에 동의한 경우
② 전기통신기본법, 전기통신사업법 등에 관계 법령에 의하여 자료 제공이 강제되는 경우이거나, 적법한 절차에 의한 법원, 수사기관, 기타 행정기관의 요청이 있는 경우
③ 홈페이지에 게시한 서비스 이용약관이나 운영정책 등 회사가 정한 정책을 위반한 경우
④ 서비스를 이용하여 타인에게 정신적, 물질적 피해를 줌으로써 그에 대한 법적인 조치를 취하기 위해 개인 정보를 공개해야 한다고 판단되는 충분한 근거가 있는 경우
⑤ 결제중재센터(https://www.spotobet.com)

<제 6조> 이용자의 권리와 그 행사방법
회원은 언제든지 개인정보의 제공 동의를 철회할 수 있습니다. 개인정보의 제공 동의 철회를 위해서는 서비스 내 “회원 탈퇴” 또는 “계정 삭제”를 클릭하여 탈퇴가 가능합니다.
또한, 등록되어 있는 자신의 개인정보를 조회하거나 수정하는 등의 법률에서 정한 권리를 행사할 수 있습니다. 이용자 및 법정대리인의 권리는 '회원정보' 페이지에서 직접 처리하거나 '문의하기'를 통해 요청할 수 있습니다. 
회원 탈퇴로 인하여 개인정보가 파기되는 경우, 해당 이용자가 회사의 서비스를 이용하면서 생성, 축적된 관련정보가 함께 파기될 수 있습니다.
이용자 ID는 어떠한 경우에도 변경이 불가능하며, 부득이한 사유로 변경하고자 한다면 해당 ID를 해지한 후 재가입해야 합니다.
이용자 ID, 비밀번호를 잊어버린 경우, 홈페이지의 "아이디 찾기 / 비밀번호 찾기 메뉴"를 이용하시기 바랍니다.
회원이 개인정보의 오류에 대한 정정을 요청한 경우, 정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다.
또한 잘못된 개인정보를 제 3자에게 이미 제공한 경우, 정정 처리결과를 제 3자에게 지체 없이 통지하여 정정이 이루어지도록 하겠습니다.
회사는 회원의 개인정보 전부 또는 일부에 대하여 열람 및 정정 요구를 거절할 정당한 사유가 있다면 회원에게 이를 지체 없이 통지하고 그 이유를 설명합니다.

<제 7조> 서비스 이용 기록 분석
회사는 회원에게 적합하고 보다 유용한 서비스를 제공하기 위해서 회원의 광고 식별자와 분석 소프트웨어를 사용하고 있습니다.
광고 식별자는 Android 광고 ID, Apple의 광고용 ID 등과 같이, 미영구적이고 비개인적인 식별자로 기기의 설정을 변경함으로써,
광고 식별자가 관심 사항에 기반하는 광고를 위해서 사용되지 못하도록 거부하거나 재설정할 수 있으며, 개인정보와 연결되거나 개인을 식별하는데 사용되지 않습니다.
분석 소프트웨어는 회원이 웹 사이트를 방문하거나 모바일 서비스를 이용할 때 자동으로 생성되는 정보를 분석하기 위해 사용되며, 회원은 이를 거부할 수 있습니다.
① 광고 식별자 수집 거부
- Android인 경우 [설정 > Google > 광고] 또는 [설정 > 일반 > 계정 및 동기화 > Goolge > 개인정보 및 개인정보보호 > 광고설정]
- IOS인 경우 [설정 > 개인정보 > 광고]
<제 8조> 개인정보의 기술적 / 관리적 / 물리적 보호대책
회사는 회원의 개인정보를 처리함에 있어 개인정보가 분실, 도난, 유출, 변조 또는 훼손되지 않도록 안전성 확보를 위해 기술적, 관리적 대책을 마련하고 이를 이행하고 있습니다.
다만, 회사가 개인정보보호 의무를 다 하였음에도 불구하고 기기 분실 등 회원 본인의 부주의로 중요 개인정보가 유출해 발생한 문제에 대해 회사는 일절 책임을 지지 않습니다.
기술적 대책
① 회사는 관련 법령에서 지정한 항목을 암호화하여 보관하고 있으며, 개인정보의 확인 및 변경은 본인의 요청을 통해서만 가능합니다.
② 회사는 암호화 통신을 통하여 네트워크 상에서 개인정보를 안전하게 전송할 수 있도록 하고 있습니다.
③ 회사는 해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위하여 보안 프로그램을 설치하고
주기적인 갱신·점검을 하며 외부로부터 접근이 통제된 구역에 시스템을 설치하고 기술적/물리적으로 감시 및 차단하고 있습니다.
④ 회사는 만약의 사태를 대비하여 개인정보를 주기적으로 백업하고 있으며, 백신 프로그램을 이용하여 컴퓨터 바이러스에 의한 피해를 예방하기 위한 조치를 취하고 있습니다.
⑤ 회사는 개인정보를 처리하는 개인정보처리시스템에 주기적인 접근 권한의 검토와 침입차단 시스템을 이용하여 내/외부로부터의 무단 접근을 통제하고 있습니다.
관리적 대책
① 회사는 회원의 개인정보에 대한 접근권한을 최소한의 인원으로 제한하고 있으며, 그 최소 인원에 해당하는 자는 다음과 같습니다.
- 회원을 직접 상대로 하여 마케팅, 이벤트, 고객지원, 배송 업무를 수행하는 자
- 개인정보보호 책임자를 포함한 개인정보보호업무를 담당하는 자
- 기타 업무상 개인정보 처리가 불가피한 자
② 회사는 개인정보취급자와 수탁사를 대상으로 개인정보보호 의무 등에 관하여 정기적으로 점검하고, 교육하고 있습니다.
③ 회사는 개인정보보호 업무를 전담하는 부서에서 개인정보처리지침을 수립하여 관리하고 있습니다.
또한 내부 규정 준수여부를 정기적으로 확인하여 문제가 발견될 경우, 즉시 바로잡을 수 있도록 노력하고 있습니다.
물리적 대책
① 비인가자에 대한 출입 통제
개인정보를 보관하고 있는 개인정보시스템의 물리적 보관 장소를 별도로 두고 이에 대해 출입통제 절차를 수립, 운영하고 있습니다.
② 문서 보안을 위한 잠금 장치 사용
개인정보가 포함된 서류, 보조저장매체 등을 잠금 장치가 있는 안전한 장소에 보관하고 있습니다.
<제 9조> 개인정보 처리 방침의 변경에 관한 사항
개인정보처리방침은 정부의 법률 및 지침 변경이나 회사의 내부 방침 변경 등으로 인하여 수시로 변경될 수 있으며, 회사가 개인정보처리방침을 개정하는 경우 그 변경사항을 이용자가 쉽게 알아볼 수 있도록 홈페이지를 통해 고지하고 있습니다. 개인정보 처리방침 변경은 게임 서비스내 '공지사항' 이력에서 변경전, 후를 비교하여 확인할 수 있습니다.
개인정보처리방침을 사이트 화면에 공개함으로써 회원이 언제나 용이하게 확인할 수 있도록 하고 있으니 사이트 방문 시 수시로 내용을 확인하시기 바랍니다.  
<제 10조> 개인정보 보호책임자 및 담당부서
회사는 회원의 개인정보를 보호하고 개인정보와 관련된 불만을 처리하기 위하여 아래와 같이 개인정보 보호책임자 및 담당부서를 지정하고 있습니다.
개인정보 보호책임자	개인정보 보호 담당부서
이 름 : 김성권
이메일 : spotobet@gmail.com	부서명 : 보안팀

기타 개인정보침해에 대한 신고나 상담이 필요한 경우, 아래 기관에 문의하시기 바랍니다.
- 개인정보침해신고센터 (http://privacy.kisa.or.kr/ 국번없이 118)
- 대검찰청 사이버범죄수사단 (http://www.spo.go.kr/ 02-3480-3571)
- 경찰청 사이버테러대응센터 (http://www.ctrc.go.kr/ 국번없이 182)

<제 11조> 고지의 의무
개인정보처리방침의 내용 추가, 삭제 및 수정이 있을 시에는 개정 7일전부터 “공지사항”을 통해 공지하는 것을 원칙으로 하며,
변경사항으로 인하여 회원에게 불이익이 발생할 수 있는 사항의 변경에 대해서는 개정 30일 이전부터 고지하도록 하겠습니다.
<부칙>
본 방침은 2025년 2월 14일부터 적용됩니다.


        `}
      </div>
    );
}

export default Private